import { useState } from 'react';

const useIsImageDark = imageSrc => {
  const [isDark, setIsDark] = useState(null);
  if (typeof window !== 'undefined' && imageSrc) {
    const fuzzy = 0.1;
    const img = window.document.createElement('img');
    img.src = imageSrc;
    img.crossOrigin = 'Anonymous';
    img.style.display = 'none';
    window.document.body.appendChild(img);

    img.onload = function() {
      const canvas = window.document.createElement('canvas');
      canvas.width = this.width;
      canvas.height = this.height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(this, 0, 0);

      try {
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const { data } = imageData;
        let r;
        let g;
        let b;
        let maxRgb;
        let light = 0;
        let dark = 0;

        for (let x = 0, len = data.length; x < len; x += 4) {
          r = data[x];
          g = data[x + 1];
          b = data[x + 2];

          maxRgb = Math.max(Math.max(r, g), b);

          if (maxRgb < 230) dark += 1;
          else light += 1;
        }

        const dlDiff = (light - dark) / (this.width * this.height);

        if (dlDiff + fuzzy < 0) {
          setIsDark(true);
        } else {
          setIsDark(false);
        }
      } catch (e) {
        console.log(e);
      }
    };
  }
  return isDark;
};

export default useIsImageDark;
